import type { IngredientId } from '@libs/trip-planner-interfaces';

import type {
  CheckboxFilterData,
  CheckboxUpdateFilterEvent,
  RangeSliderFilterData,
  RangeSliderUpdateFilterEvent,
} from '../filters';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const enum FerryFilterType {
  ArrivalTime = 'ArrivalTime',
  DepartureTime = 'DepartureTime',
  Carriers = 'Carriers',
}

export const enum FerryFiltersEventType {
  UpdateFilter = 'UpdateFilter',
}

export interface Filter<T> {
  filterType: T;
}

export interface ArrivalTimeFilter extends Filter<FerryFilterType> {
  filterType: FerryFilterType.ArrivalTime;
  filters: RangeSliderFilterData[];
  label: string;
}

export interface DepartureTimeFilter extends Filter<FerryFilterType> {
  filterType: FerryFilterType.DepartureTime;
  filters: RangeSliderFilterData[];
  label: string;
}

export interface CarriersFilter extends Filter<FerryFilterType> {
  filterType: FerryFilterType.Carriers;
  label: string;
  data: CarrersFilterData[];
}

interface CarrersFilterData {
  filters: CheckboxFilterData[];
  title: string;
  ingredientId: IngredientId;
}

export interface FerryFilters {
  ingredientId: IngredientId;
  arrivalTime: ArrivalTimeFilter;
  departureTime: DepartureTimeFilter;
  carriers: CarriersFilter;
}

interface UpdateFilterEvent<T> {
  eventType: FerryFiltersEventType.UpdateFilter;
  filterType: FerryFilterType;
  data: T;
}

export interface ArrivalTimeUpdateFilterEvent
  extends UpdateFilterEvent<RangeSliderUpdateFilterEvent> {
  eventType: FerryFiltersEventType.UpdateFilter;
  filterType: FerryFilterType.ArrivalTime;
}

export interface CarriersFilterUpdateFilterEvent
  extends UpdateFilterEvent<CheckboxUpdateFilterEvent> {
  eventType: FerryFiltersEventType.UpdateFilter;
  filterType: FerryFilterType.Carriers;
}

export interface DepartureTimeUpdateFilterEvent
  extends UpdateFilterEvent<RangeSliderUpdateFilterEvent> {
  eventType: FerryFiltersEventType.UpdateFilter;
  filterType: FerryFilterType.DepartureTime;
}

export type FerryFilterEvents =
  | ArrivalTimeUpdateFilterEvent
  | DepartureTimeUpdateFilterEvent
  | CarriersFilterUpdateFilterEvent;
